/** Estimator estimate URL — admin and estimator are sibling apps. */
import { resolveAppUrl } from '@pazportal/ui';

export function estimatorEstimateUrl(estimateId: string): string {
  return resolveAppUrl('estimator', `/estimates/${encodeURIComponent(estimateId)}`, {
    override: import.meta.env.VITE_ESTIMATOR_URL,
  });
}
